import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Routes as Switch, unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';

import { StringKeyValue } from './actions/types';
import ErrorMessage from './components/Messages/ErrorMessage';
import GlobalLoader from './containers/GlobalLoader';
import LoanApplication from './containers/LoanApplication/LoanApplication';
import LoanCalculatorContainer from './containers/LoanCalculator/LoanCalculatorContainer';
import VehicleTypeSelector from './containers/LoanCalculator/VehicleTypeSelector/VehicleTypeSelector';
import LoanCompletion from './containers/LoanCompletion/LoanCompletion';
import LoanEuroTax from './containers/LoanEuroTax/LoanEuroTax';
import LoanEuroTaxSuccess from './containers/LoanEuroTax/LoanEuroTaxSuccess';
import OngoingApplications from './containers/OngoingApplications/OngoingApplications';
import LoanApplicationReceipt from './containers/Receipts/LoanApplicationReceipt';
import customHistory from './customHistory';
import { AppState } from './reducers';
import RoutePath from './util/mappings/routePath';

interface Props {
    text: StringKeyValue;
    appType: string;
}

class Routes extends Component<Props> {
    render() {
        const { appType, text } = this.props;

        /* Global Landing Page (All apps) */
        if (appType === 'landing') {
            return (
                // @ts-ignore
                <HistoryRouter history={customHistory}>
                    <Switch>
                        <Route
                            path="/"
                            element={
                                <GlobalLoader key="1" secure>
                                    <OngoingApplications />
                                </GlobalLoader>
                            }
                        />
                        <Route path={RoutePath.loanUpgrade} element={<LoanEuroTax />} />
                        <Route path={RoutePath.loanUpgradeSuccess} element={<LoanEuroTaxSuccess />} />

                        <Route
                            path="*"
                            element={
                                <ErrorMessage
                                    title={text.pageNotFoundTitle}
                                    textList={[text.pageNotFoundText1, text.pageNotFoundText2, text.pageNotFoundText3]}
                                    infoBox={text.defaultInfoBoxText}
                                />
                            }
                        />
                    </Switch>
                </HistoryRouter>
            );
        }

        return (
            // @ts-ignore
            <HistoryRouter history={customHistory}>
                <Switch>
                    {/* Root Component */}
                    <Route
                        path="/"
                        element={
                            <GlobalLoader key="1" secure={appType !== 'calculator'}>
                                {appType === 'calculator' && <VehicleTypeSelector text={text} />}
                                {appType === 'application' && <LoanApplication />}
                                {appType === 'completion' && <LoanCompletion />}
                            </GlobalLoader>
                        }
                    />
                    {/* Calculator: Select Vehicle */}
                    <Route
                        path={RoutePath.calculator}
                        element={
                            <GlobalLoader key="2" secure={false}>
                                <VehicleTypeSelector text={text} />
                            </GlobalLoader>
                        }
                    />
                    {/* Calculator: Product */}
                    <Route
                        path={RoutePath.calculatorProduct}
                        element={
                            <GlobalLoader key="3" secure={false}>
                                <LoanCalculatorContainer />
                            </GlobalLoader>
                        }
                    />
                    {/* Application */}
                    <Route
                        path={RoutePath.application}
                        element={
                            <GlobalLoader key="5" secure>
                                <LoanApplication />
                            </GlobalLoader>
                        }
                    />
                    {/* Receipt */}
                    <Route
                        path={RoutePath.applicationReceipt}
                        element={
                            <GlobalLoader key="6" secure>
                                <LoanApplicationReceipt />
                            </GlobalLoader>
                        }
                    />
                    {/* Loan Completion */}
                    <Route
                        path={RoutePath.completion}
                        element={
                            <GlobalLoader key="7" secure>
                                <LoanCompletion />
                            </GlobalLoader>
                        }
                    />
                    <Route
                        path={RoutePath.loanUpgrade}
                        element={
                            <GlobalLoader key="8" secure>
                                <LoanEuroTax />
                            </GlobalLoader>
                        }
                    />
                    <Route
                        path={RoutePath.loanUpgradeSuccess}
                        element={
                            <GlobalLoader key="9" secure>
                                <LoanEuroTaxSuccess />
                            </GlobalLoader>
                        }
                    />

                    <Route
                        path="*"
                        element={
                            <ErrorMessage
                                title={text.pageNotFoundTitle}
                                textList={[text.pageNotFoundText1, text.pageNotFoundText2, text.pageNotFoundText3]}
                                infoBox={text.defaultInfoBoxText}
                            />
                        }
                    />
                </Switch>
            </HistoryRouter>
        );
    }
}

const mapStateToProps = (state: AppState) => ({
    text: state.context.config.data.text,
    appType: state.context.appType,
});

export default connect(mapStateToProps)(Routes);
